import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Box,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    List,
    ListItem,
    ListItemButton
} from "@mui/material";
import Add from '@mui/icons-material/Add';
import { get } from "../../../services/api-services";
import { StyledCancelButton } from "../../StyledComponent";
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { useCommon } from "../../../context/CommonContext";
const UserSupportTopics = () => {
    const { id } = useParams();
    const [userSupportTopics, setUserSupportTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const { setSnackbar } = useCommon();
    const navigate = useNavigate();

    const fetchSupportTopics = async () => {
        setLoading(true);
        const url = `/Customers/${id}/supportTopics?filter={"order" : "lastCustomerMsgOn DESC", "limit" : "5"}`;
        try {
            const response = await get(url);
            setUserSupportTopics(response.data);
        } catch (error) {
            console.error("Error fetching user support topics", error);
            if (error?.response?.status === 401) {
                setSnackbar({
                    openSnackbar: true,
                    message: 'Login expired, please login again.',
                    severity: 'error'
                })
                localStorage.clear();
                navigate("/");
            } else {
                setSnackbar({
                    openSnackbar: true,
                    message: 'Failed to load support topics.',
                    severity: 'error'
                })
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchSupportTopics();
    }, [id, navigate]);


    const handleAddMsg = () => {
        navigate('/admin/support', { state: { cId: id, returnTo: `/admin/cases/caseDetails/${id}` } })
    }
    return (
        <Card className="flex flex-1 flex-col min-h-96 xl:min-h-0">
            <CardContent className="flex flex-1 flex-col">
                <div className="flex justify-between">
                    <Typography variant="h6" fontWeight={'bold'}>
                        Support
                    </Typography>
                    <StyledCancelButton variant="outlined"
                        onClick={handleAddMsg}
                        color="primary" endIcon={<Add />}
                        className="text-base"
                    >

                        NEW MESSAGE
                    </StyledCancelButton>
                </div>
                {loading
                    ?
                    <Box container display='flex' justifyContent="center" alignItems="center" flex={1}>
                        <CircularProgress />
                    </Box>
                    : userSupportTopics?.length > 0 ? (
                        <List dense className=" h-[100%] flex flex-col justify-between">
                            {userSupportTopics?.map((topic) => (
                                <ListItem
                                    key={topic?.id || topic}
                                    secondaryAction={<ChevronRightOutlinedIcon />}
                                    disablePadding
                                    onClick={() => navigate('/admin/support', { state: { id: topic?.id, returnTo: `/admin/cases/caseDetails/${id}` } })}
                                >
                                    <ListItemButton >
                                        <Typography variant="body2" color="textSecondary" className="py-3">{topic?.topic}</Typography>

                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Typography className="flex-1 flex justify-center items-center">
                            No conversation Yet
                        </Typography>
                    )}
            </CardContent>
        </Card>

    );
};

export default UserSupportTopics;
